let food = {};

food = require('../data/food')

module.exports = food;